import React from 'react';
import  { useEffect,useState, forwardRef, useImperativeHandle  } from 'react';
import DatePicker from "react-datepicker";
import {Link, useNavigate} from 'react-router-dom';
import{useRef} from 'react';
import InviteCustomer from '../jsx/constant/ModalList';

import TechnicianSalaryReport from './TechnicianSalaryReport';

import {Tab, Nav, Dropdown} from 'react-bootstrap';
import { IMAGES } from '../jsx/constant/theme';

  import  { CurrentTimePicker } from '../jsx/components/Forms/Pickers/TimePicker';
  import MOCK_DATA from '../jsx/components/table/FilteringTable/MOCK_DATA_2.json';
  import { COLUMNS } from '../jsx/components/table/FilteringTable/Columns';
  import { GlobalFilter } from '../jsx/components/table/FilteringTable/GlobalFilter'; 
  import { useMemo } from 'react';
  import { useTable, useGlobalFilter, useFilters, usePagination } from 'react-table';
  import '../jsx/components/table/FilteringTable/filtering.css';
  import {         Col, Row } from 'react-bootstrap';
  import DateRangePicker from "react-bootstrap-daterangepicker";
  import "bootstrap-daterangepicker/daterangepicker.css";
  import axios from "axios";
  import swal from 'sweetalert';
  import Empdata from './Garantees';
  import CompanyExpenses from './AllEmpSalaries';
  import CompanyExpenses2 from './AllEmpExpences';
  import EmpLoans from '../jsx/constant/LoansReport';

  import { ToastContainer, toast } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  


    

const Employee = forwardRef((props, ref) => {

    const [data, setData] = useState([])
    const [data2, setData2] = useState([])
    const [process, setprocess] = useState(null)
//================================================================
    const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
    const userPermissions = JSON.parse(userPermissionsJSON);
    function getActionsForPage(pageName) {
      const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
   console.log('actionsForPage',pagePermissions); 
     if (pagePermissions) {
         return pagePermissions.action;
     } else {
    navigate('/dashboard_1')
        return [];
     }
   }
   const pageName = 'Empolyee';
   const actionsForPage = getActionsForPage(pageName);

   //=============================================================================================
    useEffect(() => {
     }, [])

   
    

 

    console.log(data.data)
    console.log("data",data)

    const columns = useMemo( () => COLUMNS, [] )
     
    const tableInstance = useTable({
        columns,
        data,   
        initialState : {pageIndex : 0}
    }, useFilters, useGlobalFilter, usePagination)
    const navigate = useNavigate();

    const { 
        getTableProps, 
        getTableBodyProps, 
        headerGroups, 
        prepareRow,
        state,
        page,
        gotoPage,
        pageCount,
        pageOptions,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        setGlobalFilter,
    } = tableInstance
    
    
    const {globalFilter, pageIndex} = state 
    const userdata = useRef();
const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
)

    const notifyTopRight = () => {
      toast.success("✔️ تمت عملية الحفظ بنجاح", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      });
    }; 
    const notifyInfo = () => {
        toast.info("❗ سيتم الغاء عملية ادحال البيانات ", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      };
    const [startDate, setStartDate] = useState(new Date());
   const radiocheckBox = [
    {title:'  مرتب', check: 'primary'}, {title:'   يومي', check: 'secondary'}, 
   ];
   const radiocheckBox2 = [
    {title:'  يعمل', check: 'primary'}, {title:'   في إجازة', check: 'secondary'}, {title:'   انهاء العمل', check: 'secondary'},{title:' مفصول', check: 'secondary'},
   ];
   const nav = useNavigate();
    const handleSubmit=(e)=>{
        e.preventDefault();
        nav("#");
    };
    const invite = useRef();
    const invite2 = useRef();
    const invite1 = useRef();

    const deleteUser = async (e,id)=> {
        e.preventDefault();
        swal({
          title: "هل متأكد من الحدف",
          text: " في حال حدف الملف لايمكنك استعادة هدا الملف",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then(willDelete => {
          if (willDelete) {
    
            axios.delete('https://subk.education.com.ly/back/api/products/' + id)
            
              .then(res => {
                swal({
                  title: "تم",
                  text: "تم الحدف بنجاح",
                  icon: "success",
                  timer: 2000,
                  button: false
                })
                navigate('#')
            
               
            });
        
          } else {
            swal("تم الغاء عملية الحدف");
          }
        
        });
    
    };
        const [activeLink ,setActiveLink] = useState(0);
        const [activeTab, setActiveTab] = useState('Home');
        const     activeTabfun =(pagetap)=>{
          setActiveTab(pagetap)
          navigate('/Empolyee')

        } 
    return (
        <>
            <ToastContainer />
        <div className="card">
            <div className="card-header border-0 pb-0 flex-wrap">
                <h4 className="heading mb-0">الموظف</h4>  
<div>
< Link to={"#"} className="btn btn-primary btn-sm ms-1" data-bs-toggle="offcanvas"
                                 onClick={() => invite2.current.showInviteModal()}
                               > اعمال الموظفين</Link>
                                                                                     {actionsForPage.includes('read') && (
 < Link to={"#"} className="btn btn-primary btn-sm ms-1" data-bs-toggle="offcanvas"
                                 onClick={() => invite1.current.showInviteModal()}
                               > ديون الموظفين</Link>)}
</div>
            </div>
            <div className="card-body px-3 pb-0">
                               <Tab.Container defaultActiveKey={activeTab}>
                                <div className=" tab-content">
                                <Nav as="ul" className="nav-tabs">
                                {actionsForPage.includes('create') && (
                                    <Nav.Item as="li" key='Home'>
                                      <Nav.Link eventKey={'Home'}>
                                        <i class="fas fa-user-plus ms-2"></i>
                                        تقارير الموظف
                                        </Nav.Link>
                                    </Nav.Item>
)}
 
                               
                                <Nav.Item as="li" key='masrofat'>
                                      <Nav.Link eventKey={'masrofat'}>
                                      <i class="fas fa-file-invoice-dollar ms-2"></i>    
                                        مصروفات الموظف
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li" key='masrofat'>
                                      <Nav.Link eventKey={'salary'}>
                                      <i class="fas fa-file-invoice-dollar ms-2"></i>    
                                        مرتبات الموظف
                                      </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                {actionsForPage.includes('create') && (
                                <Tab.Pane eventKey={'Home'}>                                
                     <div className="container-fluid"  >
                     <Empdata 
                     activeTab={activeTabfun}/>
                       
                    </div>
                          </Tab.Pane>
)}
                        
                        <Tab.Pane eventKey={'masrofat'}>
                        <CompanyExpenses2 />


                        </Tab.Pane>
                        <Tab.Pane eventKey={'salary'}>
                        <CompanyExpenses />


                        </Tab.Pane>
                        </div>
 
                              </Tab.Container>
             </div>
        


            </div>   
            <TechnicianSalaryReport
                            ref={invite2}     

            />
           
                <InviteCustomer
                ref={invite}     
                Title=""
            /> 
              <EmpLoans
                ref={invite1}     
             /> 
                </>
)});

export default Employee;

